// import { avatarColors } from "contains/contants";
// import React, { FC } from "react";

// export interface AvatarProps {
//   containerClassName?: string;
//   sizeClass?: string;
//   radius?: string;
//   imgUrl?: string;
//   ownerFirstName?: string;
//   ownerLastName?:string;
//   hasChecked?: boolean;
//   hasCheckedClass?: string;
// }

// const Avatar: FC<AvatarProps> = ({
//   containerClassName = "ring-1 ring-white dark:ring-neutral-900",
//   sizeClass = "h-6 w-6 text-sm",
//   radius = "rounded-full",
//   imgUrl,
//   ownerFirstName,
//   ownerLastName,
//   hasChecked,
//   hasCheckedClass = "w-4 h-4 -top-0.5 -right-0.5",
// }) => {
//   const displayImg = imgUrl || "";
//   const firstName = ownerFirstName ? ownerFirstName : "";
//   const lastName = ownerLastName ? ownerLastName : "";
//   const _setBgColor = (name: string) => {
//     const backgroundIndex = Math.floor(
//       name.charCodeAt(0) % avatarColors.length
//     );
//     return avatarColors[backgroundIndex];
//   };
//   const token = localStorage.getItem("token");
//   return (
//     <div
//       className={`wil-avatar relative flex-shrink-0 inline-flex items-center justify-center text-neutral-100 uppercase font-semibold shadow-inner ${radius} ${sizeClass} ${containerClassName}`}
//       style={{
//         backgroundColor: displayImg ? undefined : _setBgColor(firstName),
//       }}
//     >
//       {displayImg && (
//         <img
//           className={`absolute inset-0 w-full h-full object-cover ${radius}`}
//           src={displayImg}
//           alt={firstName}
//         />
//       )}
//       {token && !displayImg ? (
//           <span className="wil-avatar__name">{`${firstName[0]}${lastName[0]}`}</span>
//         ) : (
//           ""
//         )}

//       {hasChecked && (
//         <span
//           className={` bg-teal-500 rounded-full text-white text-xs flex items-center justify-center absolute  ${hasCheckedClass}`}
//         >
//           <i className="las la-check"></i>
//         </span>
//       )}
//     </div>
//   );
// };

// export default Avatar;

import { avatarColors } from "contains/contants";
import React, { FC } from "react";
import default_Img from "../../images/avatars/user_icon.png";
import { useLocation } from "react-router-dom";

export interface AvatarProps {
  containerClassName?: string;
  sizeClass?: string;
  radius?: string;
  imgUrl?: string;
  ownerFirstName?: string;
  ownerLastName?: string;
  hasChecked?: boolean;
  hasCheckedClass?: string;
}

const Avatar: FC<AvatarProps> = ({
  containerClassName = "ring-1 ring-white dark:ring-neutral-900",
  sizeClass = "lg:h-6.5 lg:w-6.5 h-2 w-2 lg:text-sm text-xs AvatarDropdown nc-AccountPage",
  radius = "rounded-full",
  imgUrl,
  ownerFirstName = "",
  ownerLastName = "",
  hasChecked,
  hasCheckedClass = "w-4 h-4 -top-0.5 -right-0.5",
}) => {
  const token = localStorage.getItem("token");
  const hasProfileImage = Boolean(imgUrl);
  const hasName = Boolean(ownerFirstName && ownerLastName);

  const _setBgColor = (name: string) => {
    if (!name) return "#ccc"; // Default fallback color
    const backgroundIndex = Math.floor(name.charCodeAt(0) % avatarColors.length);
    return avatarColors[backgroundIndex];
  };

  return (
    <div
      className={`wil-avatar relative flex-shrink-0 inline-flex items-center justify-center text-neutral-100 uppercase font-normal shadow-inner ${radius} ${sizeClass} ${containerClassName}`}
      style={{
        backgroundColor: hasProfileImage ? "transparent" : _setBgColor(ownerFirstName),
      }}
    >
      {hasProfileImage ? (
        <img
          className={`absolute inset-0 w-full h-full object-cover ${radius}`}
          src={imgUrl}
          alt={`${ownerFirstName} ${ownerLastName}`}
        />
      ) : token && hasName ? (
        <span className="wil-avatar__name">{`${ownerFirstName[0]}${ownerLastName[0]}`}</span>
      ) : (
        <img
          className={`absolute inset-0 w-full h-full object-cover ${radius}`}
          src={default_Img}
          alt="Default Avatar"
        />
      )}

      {hasChecked && (
        <span
          className={`bg-teal-500 rounded-full text-white text-xs flex items-center justify-center absolute ${hasCheckedClass}`}
        >
          <i className="las la-check"></i>
        </span>
      )}
    </div>
  );
};

export default Avatar;
